
export const nameof = <T>(name: keyof T) => name
